export default __webpack_public_path__ + "static/media/reportes.f9b31916.png";